import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { PerfilService } from 'app/_services/perfil.service';
import { BridgeService } from 'app/_services/bridge.service';
import { Observable } from 'rxjs';
import { LayoutService } from '../layout.service';

@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit, AfterViewInit {

  itemsMenu;

  clainsPorUsuarioLogado: any[] = [];

  versao: number = 0;

  constructor(
    public brigdeService: BridgeService,
    public changeDetectorRef: ChangeDetectorRef,
    public perfilService: PerfilService,
    private layoutService: LayoutService) {
  }

  ngOnInit() {
    this.itemsMenu = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["menus"];

    //TODO Remover código referente a versão (1) qdo ficar em definitivo a nova versão(2)
    // this.itemsMenu = JSON.parse(localStorage.getItem('claims'));
    // if(this.itemsMenu == null){
    //   this.ObterClainsPorUsuarioLogado();
    //   this.versao = 1;
    // }else{
    //   this.versao = 2;
    // }
  }

  ngAfterViewInit(): void {
    BridgeService.carregado.subscribe(data => {
      // this.itemsMenu = JSON.parse(localStorage.getItem('menus'));
      this.itemsMenu = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["menus"];
    });

    let isEventResize = false;

    Observable.fromEvent(window, 'resize').debounceTime(100).map(()=>{
      this.changeMenu();
      isEventResize = true;
    }).subscribe();

    if(!isEventResize)
      this.changeMenu();
  }

  private changeMenu() {
    this.layoutService.changeMenu();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/navigation.component.ts